<template>
  <div class="network-picker">
    <DropdownCheckboxSearch
      :items="formattedItems"
      :value="value"
      @input="handleInput"
      :button-text-all="allText"
      :button-text-selected="selectedText"
    />
  </div>
</template>

<script>
  import DropdownCheckboxSearch from "@/components/DropdownPicker/DropdownPicker.vue";

  export default {
    name: "NetworkPicker",
    components: {
      DropdownCheckboxSearch,
    },
    props: {
      items: {
        type: Array,
        required: true,
      },
      networkType: {
        type: Array,
      },
      value: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      formattedItems() {
        return this.items.map((item) => ({
          value: item.value,
          text: item.label,
        }));
      },
      allText() {
        if (this.networkType.length === 2) {
          return "All Networks";
        } else if (this.networkType[0] === "Mainnets") {
          return "All Mainnets";
        } else {
          return "All Testnets";
        }
      },
      selectedText() {
        if (this.networkType.length === 2) {
          return "Selected Networks";
        } else if (this.networkType[0] === "Mainnets") {
          return "Selected Mainnets";
        } else {
          return "Selected Testnets";
        }
      },
    },
    methods: {
      handleInput(selectedItems) {
        this.$emit("input", selectedItems);
      },
    },
  };
</script>
